import { render, staticRenderFns } from "./SafetyNotices.vue?vue&type=template&id=a4576a44&"
import script from "./SafetyNotices.vue?vue&type=script&lang=js&"
export * from "./SafetyNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports